/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { Node } from '@/client';

export function isDomainController(node: Node): boolean {
  return !!getActiveDirectoryProfile(node);
}

export function getActiveDirectoryProfile(node: Node) {
  return node.applicationProfiles?.find((profile) => profile.name === 'active_directory');
}
